import React from "react";
import PageHeader from "../../components/organisms/PageHeader";
import item1 from "../../assets/images/03_01_img_1.jpg"
import item2 from "../../assets/images/thumb_577_1724228841.png"
import item3 from "../../assets/images/thumb_520_1713322014.jpg"
import MainList from "../../components/organisms/MainList";

const Museum = () => {
    const navList = [
        {
            name: "강아지숲 박물관",
            link: "/program/museum"
        },
        {
            name: "상설프로그램",
            link: "/program/permanent"
        },
        {
            name: "특별프로그램",
            link: "/program/special"
        },
        {
            name: "도그 스포츠",
            link: "/program/dogsports"
        },
    ];
    const exhibitionList = [
        {
            id: 1,
            title: "상설 전시",
            img: item1,
            link: "/program/museum/permanent"
        },
        {
            id: 2,
            title: "특별 전시",
            img: item2,
            link: "/program/museum/special"
        },
        {
            id: 3,
            title: "지난 전시",
            img: item3,
            link: "/program/museum/past"
        },
    ];


    // 화면 렌더링
    return (
        <>
            <PageHeader
                bTitle="프로그램"
                detail="강아지숲 박물관"
                desc="강아지숲 박물관 전시를 안내해 드립니다."
                list={navList}
                top={true}
            />
            <MainList
                list={exhibitionList}
                columns={3}
                pagination={false}
            />
        </>
    );
};

export default Museum;
